import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { LoginComponent } from './login.component';
import { SignupComponent } from './signup.component';
import { VerifyComponent } from './verify.component';
import { DoctorDashboardComponent } from './doctor-dashboard.component';
import { AssistantDashboardComponent } from './assistant-dashboard.component';
import { PatientPortalComponent } from './patient-portal.component';
import { PatientDetailComponent } from './patient-detail.component';
import { AuthGuard } from './auth.guard';
import {ForgotPasswordComponent} from './forgot-password.component';
import { ResetPasswordComponent } from './reset-password.component';
import {
  BaseChartDirective,
  provideCharts,
  withDefaultRegisterables
} from 'ng2-charts';


const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'verify', component: VerifyComponent },
  { path: 'doctor', component: DoctorDashboardComponent, canActivate: [AuthGuard] },
  { path: 'assistant', component: AssistantDashboardComponent, canActivate: [AuthGuard] },
  { path: 'patient', component: PatientPortalComponent, canActivate: [AuthGuard] },
  { path: 'patients/:id', component: PatientDetailComponent, canActivate: [AuthGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },

];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignupComponent,
    VerifyComponent,
    DoctorDashboardComponent,
    AssistantDashboardComponent,
    PatientPortalComponent,
    PatientDetailComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent
  ],
  imports: [BrowserModule, FormsModule, BaseChartDirective, HttpClientModule, RouterModule.forRoot(routes)],
  providers: [AuthGuard, provideCharts(
      withDefaultRegisterables()
    )],
  bootstrap: [AppComponent]
})
export class AppModule {}
